import React from 'react'
import {
    Grid,
    Box,
    makeStyles,
    useTheme,
    Select,
    InputLabel,
    FormHelperText,
    Tooltip,
    IconButton,
    Typography,
} from '@material-ui/core';
import NumberFormat from 'react-number-format';
import DeleteIcon from '@material-ui/icons/Delete';

import {
    useCalculator,
    DISPATCH_UPDATE,
    DISPATCH_UPDATE_FULLTIME,
    DISPATCH_UPDATE_OVERTIME,
    DISPATCH_UPDATE_SALARY_PRIMARY,
} from '../../../state/calculatorState';
import { useLayout, SOFT_UPDATE_LAYOUT } from '../../../state/layoutState';
import {
    payOptions,
    OVERTIME_DATA_HOURLY,
    OVERTIME_DATA_DAILY,
    OVERTIME_TYPE_HOURLY,
    OVERTIME_TYPE_LOADING,
    FREQUENCY,
    HOURLY_FREQUENCY,
    FREQUENCY_PRORATA,
    FREQUENCY_PRORATA_AMOUNT,
    OVERTIME_TYPE,
    HOUR_LIMITS,
    DAY_LIMITS,
    ANNUAL_LIMITS,

    DEFAULT_WEEKS_PER_YEAR,
    DEFAULT_FORTNIGHTS_PER_YEAR,
    DEFAULT_MONTHS_PER_YEAR,

    bonusIncomeOptions,
    bonusIncomeOptionsLabel,
} from '../../../core/calculatorConstants';

import {
    StyledFeatureTextField,
    StyledTextField,
    StyledFormControl,
    StyledFeatureFormControl,
    StyledLink,
    CustomTinyButton,
    CustomFormControlLabel,
    CustomFormControlNoLabel,
    CustomFormControlFaintLabel,
    CustomSwitch,
    CustomCheckbox,


} from '../../common/CustomComponents';

import {
    FloatFormat,
    PriceFormat,
    MultiplierFormat,
    PriceIntegerFormat,
    PercentFormat,
} from '../../common/customFormatters'

import { switchFrequency, parseInputValue, formatMoney } from '../../../utils/utils';
import { isUndefined, getTaxYearIndex } from '../../../core/calculatorUtils';

import { AWARD_RATES, NBSP, STUDENT_LOANS_2026 } from '../../../constants';
import { taxData } from '../../../core/calculatorData.js';

const useStyles = makeStyles(theme => {
    return {
        root: {
            '& > *': {
                // margin: theme.spacing(1),
            },
        },

        image: {
            width: '100%',
            paddingBottom: 20,
        },

        tabs: {
            flexGrow: 1,
            padding: 20,
        },
        tab: {
            padding: 20,
        },
        contentWrapper: {
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 20,
            paddingRight: 20,
        },
        infoText: {
            fontStyle: 'italic',
            opacity: 0.5,
            color: theme.palette.primary.contrastText,
            marginLeft: 0,
            marginBottom: -8,
            paddingBottom: 0,
            letterSpacing: "-0.25px",
        },
        helperText: {
            fontStyle: 'italic',
            opacity: 0.75,
            color: theme.palette.primary.contrastText,
            marginLeft: 0,
            marginTop: 4,
            paddingBottom: 4,
            letterSpacing: "-0.25px",
        },
        helperTextInset: {
            fontStyle: 'italic',
            opacity: 0.75,
            color: theme.palette.primary.contrastText,
            marginLeft: 48,
            marginTop: -12,
            paddingBottom: 4,
            letterSpacing: "-0.25px",
        },
        switchHelperText: {
            fontStyle: 'italic',
            opacity: 0.75,
            marginTop: -18,
            paddingTop: 5,
            paddingLeft: 0,
            marginLeft: 45,
            color: theme.palette.primary.contrastText,
            letterSpacing: "-0.25px",
            lineHeight: "1.0",

        },
        switchHelperAlertText: {
            fontStyle: 'italic',
            opacity: 0.75,
            marginTop: 0,
            paddingTop: 5,
            paddingLeft: 0,
            marginLeft: 45,
            color: theme.palette.primary.contrastText,
            letterSpacing: "-0.25px",
            lineHeight: "1.0",

        },
        checkboxHelperText: {
            fontStyle: 'italic',
            opacity: 0.5,
            marginTop: -10,
            paddingLeft: 0,
            marginLeft: 0,
            color: theme.palette.primary.contrastText,
            letterSpacing: "-0.15px",
            lineHeight: "1.25",
        },
        insetInput: {
            paddingTop: 2,
            paddingLeft: 45,
        },
        button: {
            paddingLeft: 20,
            paddingRight: 20,
            borderRadius: 2,
            backgroundColor: theme.palette.secondary.light,
            color: theme.palette.grey[100]
        },
        deleteButton: {
            paddingLeft: 10,
            paddingRight: 10,
            // paddingTop:20,
            marginTop: 10,
            width: 40,
            height: 40,
        },
        seperator: {
            height: 1,
            backgroundColor: theme.palette.primary.main,
            opacity: 0.5,
            margin: '5px 0px 0 0',
        }
    }
});


export const SalaryInput = () => {
    const theme = useTheme();
    const classes = useStyles();

    let [{
        year,
        payOption,
        salary,
        salaryAnnual,
        superannuation,
        superannuationReportable,
        noSuperannuation,
        includesSuperannuation,
        HELP,
        nonResident,
        backpacker,
        overtimeSalary,
        hasBonus,
        bonusIncomeObj,
        bonusIncomeTax,
        bonusIncomeOption,

    }, dispatch] = useCalculator();
    let [, dispatchLayout] = useLayout();

    // option toggles
    let disableHELP = false;

    if (nonResident && backpacker) {
        disableHELP = true;
    }

    const handleUpdate = (data) => {
        return dispatch({
            type: DISPATCH_UPDATE,
            ...data
        })
    }

    const handleUpdateBonusAmount = (bonus) => {

        // calculate bonus as annual
        switch (Number(bonusIncomeOption)) {
            case 0: // annual
                bonusIncomeObj.a = Number(bonus);
                bonusIncomeObj.m = 0; //bonusIncomeObj.a / DEFAULT_MONTHS_PER_YEAR;
                bonusIncomeObj.f = 0; //bonusIncomeObj.a / DEFAULT_FORTNIGHTS_PER_YEAR;
                bonusIncomeObj.w = 0; //bonusIncomeObj.a / DEFAULT_WEEKS_PER_YEAR;
                bonusIncomeObj.d = 0; //bonusIncomeObj.a / DEFAULT_WEEKS_PER_YEAR / 5;
                break;
            case 1: // monthly
                bonusIncomeObj.a = Number(bonus) * DEFAULT_MONTHS_PER_YEAR;
                bonusIncomeObj.m = Number(bonus)
                bonusIncomeObj.f = 0; //bonusIncomeObj.a / DEFAULT_FORTNIGHTS_PER_YEAR;
                bonusIncomeObj.w = 0; //bonusIncomeObj.a / DEFAULT_WEEKS_PER_YEAR;
                bonusIncomeObj.d = 0; //bonusIncomeObj.a / DEFAULT_WEEKS_PER_YEAR / 5;
                break;
            case 2: // fortnightly
                bonusIncomeObj.a = Number(bonus) * DEFAULT_FORTNIGHTS_PER_YEAR;
                bonusIncomeObj.m = bonusIncomeObj.a / DEFAULT_MONTHS_PER_YEAR;
                bonusIncomeObj.f = Number(bonus)
                bonusIncomeObj.w = 0; //bonusIncomeObj.a / DEFAULT_WEEKS_PER_YEAR;
                bonusIncomeObj.d = 0; //bonusIncomeObj.a / DEFAULT_WEEKS_PER_YEAR / 5;
                break;
            case 3: // weelky
                bonusIncomeObj.a = Number(bonus) * DEFAULT_WEEKS_PER_YEAR;
                bonusIncomeObj.m = bonusIncomeObj.a / DEFAULT_MONTHS_PER_YEAR;
                bonusIncomeObj.f = bonusIncomeObj.a / DEFAULT_FORTNIGHTS_PER_YEAR;
                bonusIncomeObj.w = Number(bonus)
                bonusIncomeObj.d = 0; // bonusIncomeObj.a / DEFAULT_WEEKS_PER_YEAR / 5;
                break;
            case 4: // percent
                bonusIncomeObj.a = salaryAnnual * (Number(bonus) / 100)
                bonusIncomeObj.m = bonusIncomeObj.a / DEFAULT_MONTHS_PER_YEAR;
                bonusIncomeObj.f = bonusIncomeObj.a / DEFAULT_FORTNIGHTS_PER_YEAR;
                bonusIncomeObj.w = bonusIncomeObj.a / DEFAULT_WEEKS_PER_YEAR;
                bonusIncomeObj.d = bonusIncomeObj.a / DEFAULT_WEEKS_PER_YEAR / 5;
                break;
            default:
                break;
        }

        return dispatch({
            type: DISPATCH_UPDATE,
            bonusIncome: Number(bonusIncomeObj.a), bonusIncomeObj
        })


    }

    const optn = Number(bonusIncomeOption)
    const bonusIncomeAmount = optn === 0 ? bonusIncomeObj.a :
        optn === 1 ? bonusIncomeObj.a / DEFAULT_MONTHS_PER_YEAR :
            optn === 2 ? bonusIncomeObj.a / DEFAULT_FORTNIGHTS_PER_YEAR :
                optn === 3 ? bonusIncomeObj.a / DEFAULT_WEEKS_PER_YEAR :
                    optn === 4 ? 100 * (bonusIncomeObj.a / salaryAnnual) : 0

    const handleChangeSalary = () => event => {
        return (
            dispatch({
                type: DISPATCH_UPDATE_SALARY_PRIMARY,
                payOption,
                salary: Number(parseInputValue(event.target.value)),
            })
        )
    }


    const handleChangeCycle = () => event => {
        dispatchLayout({
            type: SOFT_UPDATE_LAYOUT,
            data: { resultsRange: Number(event.target.value) }
        })

        return (
            dispatch({
                type: DISPATCH_UPDATE,
                payOption: Number(event.target.value)
            })
        )
    }

    const fulltime = payOptions[payOption].type === "fulltime";
    const salaryType = fulltime ? "salary" : "rate";
    // const annual = payOptions[payOption].tipLabel === "year";

    const totalSuper = superannuation.a + superannuationReportable.a
    let totalPay = salaryAnnual;
    totalPay += hasBonus ? bonusIncomeObj.a : 0;
    totalPay += overtimeSalary.a
    let basePay = includesSuperannuation ? totalPay - totalSuper : totalPay


    // student loan rates
    const yearIndex = getTaxYearIndex(year);
    const helpData = taxData[yearIndex].help
    const hasWithholdingHELP = helpData.bracketsWithholding

    if(hasWithholdingHELP){
        
    }



    return (
        
        <Box className={classes.root}>

            <Grid container spacing={1} >
                <Grid item xs={12} >

                    <Grid container spacing={1}>
                        <Grid item xs={6}>

                            {/* <Box display="flex" flexDirection="row"> */}
                            <StyledFeatureTextField
                                label={`${payOptions[payOption].label} ${salaryType}`}
                                fullWidth
                                value={salary > 0 ? salary : null}
                                defaultValue={60000}
                                placeholder="Input salary"
                                variant="filled"
                                type="text"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputComponent: (payOption >= 1 ? PriceFormat : PriceIntegerFormat),
                                    inputMode: 'decimal',
                                    inputProps: {
                                        maxLength: 12,
                                        inputMode: 'decimal',
                                        pattern: "[0-9].",
                                    }
                                }}

                                onChange={handleChangeSalary()}
                                id="salary"
                            />
                        </Grid>
                        <Grid item xs={6} >
                            {/* <Box style={{ paddingLeft: 8, minWidth: 140 }}> */}
                            <StyledFeatureFormControl variant="filled" fullWidth>
                                <InputLabel htmlFor="payCycle">Pay Cycle</InputLabel>
                                <Select
                                    native
                                    variant="filled"
                                    id="payCycle"
                                    onChange={handleChangeCycle()}
                                    value={payOption}
                                >
                                    {payOptions.map((option, index) => (
                                        <option
                                            key={option.title}
                                            data={option.tipLabel}
                                            value={index}
                                        >
                                            {option.title}
                                        </option>
                                    ))}
                                </Select>
                            </StyledFeatureFormControl>
                            {/* </Box> */}
                        </Grid>
                        {/* </Box> */}
                    </Grid>



                    <Box display="flex" justifyContent="space-between" alignItems="flex-start" flexDirection="row" style={{ paddingLeft: 10, marginBottom: -25 }}>

                        <Box>
                            {payOptions[payOption].tipLabel !== "hour" && (
                                <FormHelperText className={classes.helperText}>{`Enter how much you earn per ${payOptions[payOption].tipLabel}`} </FormHelperText>
                            )}
                            {payOptions[payOption].tipLabel === "hour" && (
                                <FormHelperText className={classes.helperText}><StyledLink href={AWARD_RATES} aria-label='Award rates' rel="noopener noreferrer" target="_blank" >Check award rates</StyledLink></FormHelperText>

                            )}
                        </Box>



                    </Box>

                </Grid>
                <Grid item xs={12} md={6}>
                    <Box style={{ paddingTop: 20, paddingLeft: 15 }}>
                        {fulltime && (
                            <>
                                <ProrataOptions />
                                <Overtime data_template = {OVERTIME_DATA_DAILY} />
                            </>
                        )}
                        <CasualDailyOptions />
                        <CasualHourlyOptions />
                    </Box>



                </Grid>
                <Grid item xs={12} md={6} style={{ display: 'flex', flexDirection: 'column', paddingLeft: 0, paddingBottom: 20, paddingTop: 0, width: '100%' }}>
                    <Box style={{ paddingLeft: 20 }}>
                        <CustomFormControlLabel
                            style={{ width: '100%' }}
                            control={
                                <CustomSwitch
                                    id="BonusPaySwitch"
                                    checked={hasBonus}
                                    onChange={(event) => handleUpdate({ hasBonus: (event.target.checked) })}
                                    color="primary"
                                />
                            }
                            label={"Bonus Pay"}
                        />
                        {hasBonus && (
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <StyledTextField
                                        label={bonusIncomeOptionsLabel[bonusIncomeOption]}
                                        fullWidth
                                        value={bonusIncomeAmount > 0 ? bonusIncomeAmount : ''}
                                        defaultValue={0}
                                        placeholder=""
                                        variant="filled"
                                        type="text"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            inputComponent: optn === 4 ? PercentFormat : PriceIntegerFormat,
                                            inputMode: 'decimal',
                                            inputProps: {
                                                maxLength: 12,
                                                inputMode: 'decimal',
                                                pattern: "[0-9].",
                                            }
                                        }}

                                        onChange={(event) => handleUpdateBonusAmount(event.target.value)}
                                        id="bonusIncome"
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <StyledFormControl variant="filled" fullWidth >
                                        <InputLabel htmlFor="bonusIncomeOptions">Frequency</InputLabel>
                                        <Select
                                            native
                                            variant="filled"
                                            id="bonusIncomeOption"
                                            onChange={(event) => handleUpdate({ bonusIncomeOption: (event.target.value) })}
                                            value={bonusIncomeOption}
                                        >
                                            {bonusIncomeOptions.map((option, index) => (
                                                <option
                                                    key={option}
                                                    value={index}
                                                >
                                                    {option}
                                                </option>
                                            ))}
                                        </Select>
                                    </StyledFormControl>
                                </Grid>
                                <Grid item xs={12} style={{ textAlign: 'end' }} >
                                    <Typography display="inline" style={{ fontSize: '1.0em', color: theme.palette.secondary.main, opacity: 1 }}>
                                        {bonusIncomeTax !== 0 ? (
                                            `$${formatMoney(parseInputValue(bonusIncomeTax), 2)} tax ${bonusIncomeTax >= 0 ? 'saving' : 'liability'}`
                                        ) : (
                                            NBSP
                                        )
                                        }
                                    </Typography>
                                </Grid>
                            </Grid>

                        )}

                        <Tooltip
                            enterDelay={500}
                            title="Typically Superannuatuion is not included in your salary and is paid on top of your ordinary time earnings."
                            placement="top">

                            <>

                                <CustomFormControlLabel
                                    control={
                                        <CustomSwitch
                                            id="SalaryIncludeSuperSwitch"
                                            disabled={noSuperannuation}
                                            // size="small"
                                            checked={includesSuperannuation}
                                            onChange={(event) => handleUpdate({ includesSuperannuation: (event.target.checked) })}
                                            color="primary"
                                        />
                                    }
                                    label={"Salary includes Superannuation"}
                                // label={ includesSuperannuation ? "Superannuation paid on top of salary" : "Salary includes Superannuation"}
                                />
                                {/* <FormHelperText className={classes.switchHelperText} >{includesSuperannuation ? "Super is taken out of your salary" : "Super is paid in addition to your salary"}</FormHelperText> */}


                                <FormHelperText className={classes.switchHelperText} >
                                    {includesSuperannuation ? (
                                        `Your $${formatMoney(totalPay, 0)} salary package includes $${formatMoney(basePay, 0)} base salary + $${formatMoney(totalSuper, 0)} super`
                                        // `Your annual salary of $${formatMoney(salaryAnnual, 0)} includes $${formatMoney(totalSuper, 0)} of super guarantee`
                                    ) : (
                                        `Super Guarantee of $${formatMoney(totalSuper, 0)} is paid on top of your $${formatMoney(totalPay, 0)} annual salary`
                                    )} </FormHelperText>


                            </>
                        </Tooltip>


                        <CustomFormControlLabel
                            control={
                                <CustomSwitch
                                    id="StudentLoanSwitch"
                                    checked={disableHELP ? false : HELP}
                                    disabled={disableHELP}
                                    onChange={disableHELP ? null : (event) => handleUpdate({ HELP: (event.target.checked) })}
                                    color="primary"
                                />
                            }
                            label={`Student loan`}
                        />
                        <FormHelperText className={classes.switchHelperText}>{`HELP (HECS), VSL, TSL, SSL, SFSS`} </FormHelperText>
                        {hasWithholdingHELP && HELP && (
                            <FormHelperText className={classes.switchHelperAlertText}>Note: Only annual amounts use the <StyledLink href={STUDENT_LOANS_2026} aria-label='Student loan rates' rel="noopener noreferrer" target="_blank" >new rates </StyledLink></FormHelperText>
                        )
                        }

                    </Box>

                </Grid>
            </Grid>
        </Box>

    )
}




// --------------------------------------------------------------------------------
// PRORATA
// --------------------------------------------------------------------------------

const ProrataOptions = () => {
    // observe Hook rules - declare 'use' regardless of conditionals
    const classes = useStyles();
    const [{ payOption, adjustProRata, proRataAmount, proRataAmountFrequency, proRataFrequency, proRataPercent }, dispatch] = useCalculator();

    const fulltime = payOptions[payOption].type === "fulltime";

    let amountFrequency = FREQUENCY_PRORATA_AMOUNT[proRataAmountFrequency];
    let frequency = FREQUENCY_PRORATA[proRataFrequency];
    if (proRataAmount < 2) amountFrequency = amountFrequency.split("s").join("");
    let proRataDescription = `${proRataAmount} ${amountFrequency} each ${frequency}`;
    proRataDescription = `You work ${proRataDescription.toLowerCase()} or ${Math.round(proRataPercent * 1000) / 10}% prorata`;

    const handleUpdate = (data) => dispatch({
        type: DISPATCH_UPDATE,
        ...data
    })

    if (!fulltime) return false;

    const proRateLabel = FREQUENCY_PRORATA_AMOUNT[proRataAmountFrequency]

    return (
        <Grid container spacing={1} direction="row">
            <Grid item>
                <CustomFormControlNoLabel
                    control={
                        <CustomSwitch
                            id="ProRataSwitch"
                            checked={adjustProRata}
                            onChange={(event) => handleUpdate({ adjustProRata: (event.target.checked) })}
                            color="primary"
                        />
                    }
                    label={`Pro-rata / Part-time hours`}
                />
                {/* <FormHelperText className={classes.switchHelperText}>{adjustProRata ? `You are on reduced hours` : ` .`} </FormHelperText> */}
            </Grid>
            {adjustProRata && (
                <Grid container spacing={1} direction="row">
                    <Grid item xs={4} >
                        <StyledTextField
                            label={proRateLabel}
                            aria-label={proRateLabel}
                            value={proRataAmount > 0 ? proRataAmount : null}
                            defaultValue={0}
                            variant="filled"
                            name="hours"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                'aria-label': proRateLabel,
                                inputMode: 'decimal',
                                inputComponent: FloatFormat,
                                inputProps: {
                                    inputMode: 'decimal',
                                }
                            }}
                            onChange={event => handleUpdate({ proRataAmount: parseInputValue(event.target.value) })}
                        />
                    </Grid>
                    <Grid item xs={4} >
                        <StyledFormControl variant="filled" fullWidth >
                            <Select
                                native
                                aria-label={proRataAmountFrequency}
                                variant="filled"
                                name="frequency"
                                value={proRataAmountFrequency}
                                onChange={event => handleUpdate({ proRataAmountFrequency: event.target.value })}
                            >
                                {FREQUENCY_PRORATA_AMOUNT.map((option, index) => (
                                    <option
                                        key={"REQUENCY_PRORATA_AMOUNT" + index}
                                        value={index}
                                    >
                                        {option}
                                    </option>
                                ))}
                            </Select>
                        </StyledFormControl>
                    </Grid>
                    <Grid item xs={4} >
                        <StyledFormControl variant="filled" fullWidth >
                            <InputLabel htmlFor="frequency">each</InputLabel>
                            <Select
                                native
                                variant="filled"
                                aria-label={proRataFrequency}
                                name="frequency"
                                value={proRataFrequency}
                                onChange={event => handleUpdate({ proRataFrequency: event.target.value })}
                            >
                                {FREQUENCY_PRORATA.map((option, index) => (
                                    <option
                                        key={"FREQUENCY_PRORATA" + index}
                                        value={index}
                                    >
                                        {option}
                                    </option>
                                ))}
                            </Select>
                        </StyledFormControl>
                    </Grid>
                    <FormHelperText className={classes.helperText}>{proRataDescription} </FormHelperText>
                </Grid>


            )}
        </Grid>
    );


}


// --------------------------------------------------------------------------------
// DAILY
// --------------------------------------------------------------------------------

const CasualDailyOptions = () => {
    // observe Hook rules - declare 'use' regardless of conditionals
    const classes = useStyles();
    const theme = useTheme()
    const [{ casual, payOption, fulltime }, dispatch] = useCalculator();

    if (payOptions[payOption].type !== "daily") return null;

    const handleUpdateFulltime = (data) => dispatch({
        type: DISPATCH_UPDATE_FULLTIME,
        ...data
    })


    const handleChangeCasual = (event) => {
        const name = event.target.name;
        const value = parseInputValue(event.target.value)
        const data = { ...casual };

        if (name === "frequency") {
            // adjust the annual frequency with the frequency
            const r = switchFrequency(data['frequency'], value);
            data["annual"] = Math.round(Number(data["annual"]) / r);
        }
        data[name] = value;

        dispatch({
            type: DISPATCH_UPDATE,
            ...{ casual: data }
        })
    }


    const errorDays = checkLimit(casual.frequency, casual.days, "days");
    const errorAnnual = checkLimit(casual.frequency, casual.annual, "annual");


    const daysMessage = errorDays ? `Too many many days per ${casual.frequency.toLowerCase()}!` : `Set how many days per ${casual.frequency.toLowerCase()} you work`;
    const annualMessage = errorAnnual ? `Too many many ${casual.frequency.toLowerCase()}s per year!` : `Number of ${casual.frequency.toLowerCase()}s per year ONLY applies to annual figures.`;


    let showAnnual = true;
    if (casual.frequency === FREQUENCY[FREQUENCY.length - 1]) showAnnual = false;


    return (
        <>
            <Grid container direction="row">
                <Grid item>

                    <CustomFormControlNoLabel
                        control={
                            <CustomSwitch
                                id="CasualSwitch"
                                checked={!fulltime}
                                onChange={(event) => handleUpdateFulltime({ fulltime: (!event.target.checked) })}
                                color="primary"
                            />
                        }
                        label={`Casual or Part-time hours`}
                    />

                    {fulltime && (
                        <FormHelperText className={classes.helperTextInset} >Fulltime, 5 days per week. Includes annual leave and public holidays</FormHelperText>
                    )}
                </Grid>
            </Grid>

            {!fulltime && (
                <>
                    <Grid container spacing={1} direction="row">
                        <Grid item xs={12} style={{ marginBottom: -10, marginTop: 15 }}>
                            <Box style={{ width: '100%', height: 1, backgroundColor: theme.palette.background.overlay }}></Box>
                            <h3>ORDINARY HOURS</h3>
                        </Grid>
                        <Grid item xs={6} >
                            <StyledTextField
                                fullWidth
                                error={errorDays}
                                label="Days"
                                value={casual.days > 0 ? casual.days : null}
                                defaultValue={0}
                                variant="filled"
                                name="days"
                                type="text"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputMode: 'decimal',
                                    inputComponent: FloatFormat,
                                    inputProps: {
                                        inputMode: 'decimal',
                                    }
                                }}
                                onChange={event => handleChangeCasual(event)}
                            />
                        </Grid>
                        <Grid item xs={6} >
                            <StyledFormControl variant="filled" fullWidth >
                                <InputLabel htmlFor="frequency">each</InputLabel>
                                <Select
                                    native
                                    fullWidth
                                    variant="filled"
                                    name="frequency"
                                    value={casual.frequency}
                                    // defaultValue={casual.frequency}
                                    onChange={event => handleChangeCasual(event)}
                                >
                                    {FREQUENCY.map((option, index) => (
                                        <option
                                            key={"option" + index}
                                        >
                                            {option}
                                        </option>
                                    ))}
                                </Select>
                            </StyledFormControl>
                        </Grid>
                    </Grid>
                    <FormHelperText className={classes.helperText}>{daysMessage} </FormHelperText>

                    <Grid container spacing={1} direction="row">
                        {showAnnual && (
                            <>
                                <Grid item xs={6} >
                                    <StyledTextField
                                        fullWidth
                                        error={errorAnnual}
                                        label={`${casual.frequency}s`}
                                        value={casual.annual > 0 ? casual.annual : null}
                                        defaultValue={0}

                                        variant="filled"
                                        name="annual"
                                        type="text"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            inputMode: 'decimal',
                                            inputComponent: FloatFormat,
                                            inputProps: {
                                                inputMode: 'decimal',
                                            }
                                        }}
                                        onChange={event => handleChangeCasual(event)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <StyledTextField
                                        fullWidth
                                        label={`each`}
                                        value={`Year`}
                                        variant="filled"
                                        disabled
                                    />
                                </Grid>
                                <FormHelperText className={classes.helperText} style={{ marginLeft: 10, marginTop: 0 }}>{annualMessage} </FormHelperText>
                            </>
                        )}
                    </Grid>
                    {showAnnual && (
                        <UnpaidLeave />
                    )}
                </>
            )}

            <Overtime data_template={OVERTIME_DATA_DAILY}/>
        </>
    )
}





// --------------------------------------------------------------------------------
// HOURLY
// --------------------------------------------------------------------------------
const CasualHourlyOptions = () => {
    // observe Hook rules - declare 'use' regardless of conditionals
    const classes = useStyles();
    const theme = useTheme()
    const [{ payOption, casual, fulltime }, dispatch] = useCalculator();

    if (payOptions[payOption].type !== "hourly") return null;


    const handleUpdateFulltime = (data) => dispatch({
        type: DISPATCH_UPDATE_FULLTIME,
        ...data
    })


    const handleChange = (event) => {
        const name = event.target.name;
        const value = parseInputValue(event.target.value)
        const data = { ...casual };

        if (name === "frequency") {
            // adjust the annual frequency with the frequency
            const r = switchFrequency(data['frequency'], value);
            data["annual"] = Math.round(Number(data["annual"]) / r);
        }

        if (name === "frequency_day") {
            // adjust the annual frequency with the frequency
            const r = switchFrequency(data['frequency_day'], value);
            data["annual"] = Math.round(Number(data["annual"]) / r);
        }

        data[name] = value;


        dispatch({
            type: DISPATCH_UPDATE,
            ...{ casual: data }
        })
    }



    const HOURS_PER_DAY = casual.frequency === HOURLY_FREQUENCY[0];

    const errorHours = HOURS_PER_DAY ? checkLimit(casual.frequency, casual.hours, "hoursPerDay") : checkLimit(casual.frequency, casual.hours, "hours");
    const errorDays = checkLimit(casual.frequency_day, casual.days, "days");

    const errorAnnual = HOURS_PER_DAY ? checkLimit(casual.frequency_day, casual.annual, "annual") : checkLimit(casual.frequency, casual.annual, "annual");

    const hoursMessage = errorHours ? `Too many many hours per ${casual.frequency.toLowerCase()}!` : `Set how many hours per ${casual.frequency.toLowerCase()} you work`;
    const annualMessage = errorAnnual ? `Too many many ${HOURS_PER_DAY ? casual.frequency_day.toLowerCase() : casual.frequency.toLowerCase()}s per year!` : `Number of ${casual.frequency.toLowerCase()}s per year ONLY applies to annual figures.`;


    let showAnnual = true;
    if (casual.frequency === FREQUENCY[FREQUENCY.length - 1]) showAnnual = false;
    if (HOURS_PER_DAY && casual.frequency_day === FREQUENCY[FREQUENCY.length - 1]) showAnnual = false;

    return (
        <React.Fragment>
            <Grid container direction="row">
                <Grid item>
                    <CustomFormControlNoLabel
                        control={
                            <CustomSwitch
                                id="PartTimeSwitch"
                                checked={!fulltime}
                                onChange={(event) => handleUpdateFulltime({ fulltime: (!event.target.checked) })}
                                color="primary"
                            />
                        }
                        label={`Casual or Part-time hours`}
                    />
                    {fulltime && (
                        <FormHelperText className={classes.helperTextInset}>Fulltime, 38 hours per week. Includes annual leave and public holidays</FormHelperText>
                    )}
                </Grid>
            </Grid>

            {!fulltime && (
                <>

                    <Grid item xs={12} style={{ marginBottom: -10, marginTop: 15 }}>
                        <Box style={{ width: '100%', height: 1, backgroundColor: theme.palette.background.overlay }}></Box>
                        <h3>ORDINARY HOURS</h3>
                    </Grid>

                    <Grid container spacing={1} direction="row">
                        <Grid item xs={6} >
                            <StyledTextField
                                fullWidth
                                label="Hours"
                                error={errorHours}
                                value={casual.hours > 0 ? casual.hours : null}
                                defaultValue={0}
                                variant="filled"
                                name="hours"
                                type="text"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputMode: 'decimal',
                                    inputComponent: FloatFormat,
                                    inputProps: {
                                        inputMode: 'decimal',
                                    }
                                }}
                                onChange={event => handleChange(event)}
                            />
                        </Grid>
                        <Grid item xs={6} >
                            <StyledFormControl variant="filled" fullWidth >
                                <InputLabel htmlFor="frequency">each</InputLabel>
                                <Select
                                    fullWidth
                                    native
                                    variant="filled"
                                    name="frequency"
                                    value={casual.frequency}
                                    onChange={event => handleChange(event)}
                                >
                                    {HOURLY_FREQUENCY.map((option, index) => (
                                        <option key={"option" + index}>
                                            {option}
                                        </option>
                                    ))}
                                </Select>
                            </StyledFormControl>
                        </Grid>
                    </Grid>
                    <FormHelperText className={classes.helperText}>{hoursMessage} </FormHelperText>


                    {HOURS_PER_DAY && (
                        <Grid container spacing={1} direction="row">
                            <Grid item xs={6} >
                                <StyledTextField
                                    fullWidth
                                    label="Days"
                                    error={errorDays}
                                    value={casual.days > 0 ? casual.days : null}
                                    defaultValue={0}
                                    variant="filled"
                                    name="days"
                                    type="text"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        inputMode: 'decimal',
                                        inputComponent: FloatFormat,
                                        inputProps: {
                                            inputMode: 'decimal',
                                        }
                                    }}
                                    onChange={event => handleChange(event)}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <StyledFormControl variant="filled" fullWidth >
                                    <InputLabel htmlFor="frequency">each</InputLabel>
                                    <Select
                                        fullWidth
                                        native
                                        variant="filled"
                                        name="frequency_day"
                                        value={casual.frequency_day}
                                        onChange={event => handleChange(event)}
                                    >
                                        {FREQUENCY.map((option, index) => (
                                            <option key={"option" + index}>
                                                {option}
                                            </option>
                                        ))}
                                    </Select>
                                </StyledFormControl>
                            </Grid>
                        </Grid>

                    )}

                    <Grid container spacing={1} direction="row">
                        {showAnnual && (
                            <>
                                <Grid item xs={6} >
                                    <StyledTextField
                                        fullWidth
                                        label={`${(casual.frequency === HOURLY_FREQUENCY[0] ? casual.frequency_day : casual.frequency)}s`}
                                        error={errorAnnual}
                                        value={casual.annual > 0 ? casual.annual : null}
                                        defaultValue={0}
                                        variant="filled"
                                        name="annual"
                                        type="text"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            inputMode: 'decimal',
                                            inputComponent: FloatFormat,
                                            inputProps: {
                                                inputMode: 'decimal',
                                            }
                                        }}
                                        onChange={event => handleChange(event)}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <StyledTextField
                                        fullWidth
                                        label={`each`}
                                        value={`Year`}
                                        variant="filled"
                                        disabled
                                    />
                                </Grid>
                                <FormHelperText className={classes.helperText} style={{ marginLeft: 10, marginTop: 0 }} >{annualMessage} </FormHelperText>
                            </>
                        )}
                    </Grid>
                    {showAnnual && (
                        <UnpaidLeave />
                    )}
                </>
            )}

            <Overtime data_template = {OVERTIME_DATA_HOURLY}/>

        </React.Fragment >
    )
}


// --------------------------------------------------------------------------------
// UNPAID
// --------------------------------------------------------------------------------
const UnpaidLeave = () => {
    // observe Hook rules - declare 'use' regardless of conditionals
    const classes = useStyles();
    const theme = useTheme()
    const [{ includeUnpaidLeave, unpaidPublicHolidays, unpaidLeave }, dispatch] = useCalculator();


    const handleUpdate = (data) => dispatch({
        type: DISPATCH_UPDATE,
        ...data
    })

    return (
        <Grid container spacing={1}>
            <Box style={{ width: '100%', height: 1, backgroundColor: theme.palette.background.overlay, marginBottom:0, marginTop: 20 }}></Box>
            <Grid item xs={12} style={{ marginBottom: -15, marginTop: -5 }}>
                <h3>LEAVE</h3>
            </Grid>
            <Grid item>

                <CustomFormControlLabel
                    control={
                        <CustomSwitch
                            id="DeductUnpaidLeaveSwitch"
                            checked={includeUnpaidLeave}
                            onChange={(event) => handleUpdate({ includeUnpaidLeave: (event.target.checked) })}
                            color="primary"
                        />
                    }
                    label={`Deduct unpaid leave and public holidays`}
                />

                {includeUnpaidLeave ? (
                    <FormHelperText className={classes.switchHelperText} >Set the number of days in the year where leave was unpaid</FormHelperText>
                ) : (
                    <FormHelperText className={classes.switchHelperText} >No days are treated as unpaid leave, sick leave or public holidays</FormHelperText>
                )}
            </Grid>

            {includeUnpaidLeave && (
                <>


                    <Grid item xs={6}>
                        <StyledTextField
                            fullWidth
                            label="Public Holidays"
                            value={unpaidPublicHolidays > 0 ? unpaidPublicHolidays : 0}
                            defaultValue={0}
                            variant="filled"
                            name="hours"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                inputMode: 'decimal',
                                inputComponent: FloatFormat,
                                inputProps: {
                                    inputMode: 'decimal',
                                }
                            }}
                            onChange={event => handleUpdate({ unpaidPublicHolidays: event.target.value })}
                        />
                        <FormHelperText className={classes.helperText}>Total unpaid annual public holidays</FormHelperText>
                    </Grid>
                    <Grid item xs={6} >
                        <StyledTextField
                            fullWidth
                            label="Annual Leave"
                            value={unpaidLeave > 0 ? unpaidLeave : 0}
                            defaultValue={0}
                            variant="filled"
                            name="hours"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                inputMode: 'decimal',
                                inputComponent: FloatFormat,
                                inputProps: {
                                    inputMode: 'decimal',
                                }
                            }}
                            onChange={event => handleUpdate({ unpaidLeave: event.target.value })}
                        />
                        <FormHelperText className={classes.helperText}>Total unpaid annual leave</FormHelperText>
                    </Grid>
                </>
            )}
            {/* <Box style={{ width: '100%', height: 1, backgroundColor: theme.palette.background.overlay }}></Box> */}
        </Grid>
    )

}




// --------------------------------------------------------------------------------
// OVERTIME
// --------------------------------------------------------------------------------

const Overtime = ({data_template}) => {
    const theme = useTheme();
    // observe Hook rules
    const classes = useStyles();
    const [{ overtime, payOption, salary }, dispatch] = useCalculator();

    // Append a new "OVERTIMRE_DATA object onto the overtime state
    const addOvertime = () => {
        const defaultOvertimeData = { ...data_template };
        if(defaultOvertimeData.type === OVERTIME_TYPE_HOURLY) defaultOvertimeData.rate = salary;
        dispatch({ type: DISPATCH_UPDATE, overtime: overtime.concat({ ...defaultOvertimeData }) })
    }


    const deleteOvertime = (index) => {
        overtime.splice(index, 1)
        let data = { overtime };
        dispatch({
            type: DISPATCH_UPDATE_OVERTIME,
            ...data
        })
    }

    const handleChangeOvertime = (event, index) => {
        const hourlyRate = salary;
        const name = event.target.name;
        const value = parseInputValue(event.target.value);
        const data = [...overtime];

        switch (name) {
            case "hours":
                data[index][name] = Number(value);
                break;
            case "type":
                data[index][name] = value;
                break;
            case "annualFrequency":
                data[index][name] = Number(value);
                break;

            case "frequency":
                // adjust the annual frequency with the frequency
                const r = switchFrequency(data[index]['frequency'], value);
                data[index]["annualFrequency"] = Math.round(data[index]["annualFrequency"] / r);

                data[index][name] = value;
                break;
            case "hourlyRate":
                data[index][name] = Number(value);
                if (hourlyType) {
                    data[index].loadingRate = Number(value / hourlyRate);
                } else {
                    // data[index].loadingRate = 1
                }
                break;
            case "loadingRate":
                data[index][name] = Number(value);
                // this is only available in hourlyType mode
                data[index].hourlyRate = Number(hourlyRate * data[index].hours * data[index].loadingRate);
                break;
            default: return;
        }
        dispatch({
            type: DISPATCH_UPDATE_OVERTIME,
            ...{ overtime: data }
        })

    }

    const handleChangeSuper = (checked, index) => {
        const data = [...overtime];
        data[index].super = checked;
        dispatch({
            type: DISPATCH_UPDATE_OVERTIME,
            ...{ overtime: data }
        })
    }


    // only include hourly rate if hourly rate is set via pay cycle
    const hourlyType = payOptions[payOption].type.indexOf("hour") >= 0

    return (
        <React.Fragment>
            <Grid item xs={12} style={{ marginBottom: 15, marginTop: 15 }}>
                <Box style={{ width: '100%', height: 1, backgroundColor: theme.palette.background.overlay }}></Box>
            </Grid>
            <h3>OVERTIME</h3>
            {overtime.map((ot, index) => {
                const hourlyRate = salary;
                let overtime_value = (hourlyType && ot.type === OVERTIME_TYPE_LOADING) ? ot.hours * ot.loadingRate * hourlyRate : ot.hours * ot.hourlyRate;
                overtime_value = overtime_value > 0 ? (
                    <NumberFormat decimalScale={2} value={(overtime_value)} displayType={'text'} thousandSeparator={true} prefix={'$'} />) : ('$0')
                return (
                    <Box key={"overtime" + index} style={{ paddingBottom: 15 }}>
                        {hourlyType ? renderOvertimeHourly(ot, index, handleChangeOvertime, deleteOvertime, classes) : renderOvertimeDaily(ot, index, handleChangeOvertime, deleteOvertime, classes)}
                        <Grid container direction="row" spacing={1}>
                            <Grid item xs={6}>
                                {/* <Box display="flex" flexDirection="row" justifyContent="space-between"  > */}
                                <FormHelperText className={classes.helperText} >
                                    Overtime of {overtime_value} per {ot.frequency.toLowerCase()}
                                </FormHelperText>
                            </Grid>
                            <Grid item xs={6}>
                                <Box display="flex" flexDirection="column">
                                    <CustomFormControlFaintLabel
                                        style={{ marginTop: -8 }}
                                        control={
                                            <CustomCheckbox
                                                name="super"
                                                disabled={overtime_value === 0}
                                                checked={ot.super}
                                                onChange={event => handleChangeSuper(event.target.checked, index)}
                                                color="primary"
                                            />
                                        }
                                        label='Include Superannuation'
                                    />
                                    <FormHelperText className={classes.checkboxHelperText} >
                                        (Overtime pay usually excludes Super)
                                    </FormHelperText>
                                </Box>
                            </Grid>
                        </Grid>
                        {/* </Box> */}
                    </Box>
                )
            })}
<div style={{ alignItems: "flex-start", paddingTop: 5, paddingBottom: 15, paddingRight: 5 }}>
                <CustomTinyButton
                    tabIndex="-1"
                    style={{ display: "block", marginTop: 0, marginRight: 0 }}
                    variant="contained"
                    onClick={() => addOvertime(overtime)}
                >
                    Add Overtime
                </CustomTinyButton>
            </div>
        </React.Fragment >
    )
}


const renderOvertimeHourly = (ot, index, handleChangeOvertime, deleteOvertime, classes) => {
    return (
        <React.Fragment key={"hourly" + index}>
            <Grid container key={"overtime" + index} direction="row" spacing={1}>
                <Grid item xs={4}>

                    {ot.type === OVERTIME_TYPE_HOURLY ? (
                        <StyledTextField
                            label="Hourly rate"
                            name="hourlyRate"
                            value={ot.hourlyRate > 0 ? ot.hourlyRate : null}
                            defaultValue={0}
                            variant="filled"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                inputMode: 'decimal',
                                inputComponent: PriceFormat,
                                inputProps: {
                                    inputMode: 'decimal',
                                }
                            }}
                            onChange={event => handleChangeOvertime(event, index)}
                        />
                    ) : (
                        <StyledTextField
                            label="Loading rate"
                            name="loadingRate"
                            value={ot.loadingRate > 0 ? ot.loadingRate : null}
                            defaultValue={0}
                            variant="filled"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                inputMode: 'decimal',
                                inputComponent: MultiplierFormat,
                                inputProps: {
                                    inputMode: 'decimal',
                                }
                            }}
                            onChange={event => handleChangeOvertime(event, index)}
                        />

                    )}
                </Grid>
                <Grid item xs={7} >
                    <StyledFormControl variant="filled" fullWidth >
                        <InputLabel htmlFor="frequency">calculation</InputLabel>
                        <Select
                            native
                            variant="filled"
                            name="type"
                            value={ot.type}
                            onChange={event => handleChangeOvertime(event, index)}
                        >
                            {OVERTIME_TYPE.map((option, index) => (
                                <option key={"type" + index} value={option}>
                                    {`${option} rate`}
                                </option>
                            ))}
                        </Select>
                    </StyledFormControl>

                </Grid>

                <Grid item xs={1} >
                    <Tooltip title={`Delete overtime`} placement="top">
                        <IconButton tabIndex="-1" aria-label="delete" className={classes.deleteButton} size="small" onClick={() => deleteOvertime(index)}>
                            <DeleteIcon fontSize="inherit" />
                        </IconButton>
                    </Tooltip>


                </Grid>

                <Grid item xs={4} >
                    <StyledTextField
                        label="Hours"
                        value={ot.hours > 0 ? ot.hours : null}
                        defaultValue={0}
                        variant="filled"
                        name="hours"
                        type="text"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            inputMode: 'decimal',
                            inputComponent: FloatFormat,
                            inputProps: {
                                inputMode: 'decimal',
                            }
                        }}
                        onChange={event => handleChangeOvertime(event, index)}
                    />
                </Grid>
                <Grid item xs={7}>
                    <StyledFormControl variant="filled" fullWidth >
                        <InputLabel htmlFor="frequency">each</InputLabel>
                        <Select
                            native
                            value={ot.frequency}
                            variant="filled"
                            name="frequency"
                            onChange={event => handleChangeOvertime(event, index)}
                        >
                            {FREQUENCY.map((option, index) => (
                                <option key={"option" + index}>
                                    {option}
                                </option>
                            ))}
                        </Select>
                    </StyledFormControl>
                </Grid>
                <Grid item xs={1}></Grid>



                {ot.frequency !== "Year" && (
                    // WEEK
                    <>
                        <Grid item xs={4} >
                            <StyledTextField
                                //fullWidth
                                label={`${ot.frequency}s`}
                                value={ot.annualFrequency > 0 ? ot.annualFrequency : null}
                                defaultValue={0}
                                variant="filled"
                                name="annualFrequency"
                                type="text"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputMode: 'decimal',
                                    inputComponent: FloatFormat,
                                    inputProps: {
                                        inputMode: 'decimal',
                                    }
                                }}
                                onChange={event => handleChangeOvertime(event, index)}
                            />
                        </Grid>

                        <Grid item xs={7}>
                            <StyledTextField
                                fullWidth
                                label={`each`}
                                value={`Year`}
                                variant="filled"
                                disabled
                            />
                        </Grid>
                        <Grid item xs={1}></Grid>
                    </>
                )}

            </Grid>
        </React.Fragment>
    )
}


const renderOvertimeDaily = (ot, index, handleChangeOvertime, deleteOvertime, classes) => {
    return (
        <React.Fragment key={"daily" + index}>
            <Grid container key={"overtime" + index} style={{ width: '100%' }} direction="row" spacing={1}>
                <Grid item xs={3} >
                    <StyledTextField
                        label="Hours"
                        value={ot.hours > 0 ? ot.hours : null}
                        defaultValue={0}
                        variant="filled"
                        name="hours"
                        type="text"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            inputMode: 'decimal',
                            inputComponent: FloatFormat,
                            inputProps: {
                                inputMode: 'decimal',
                            }
                        }}
                        onChange={event => handleChangeOvertime(event, index)}
                    />
                </Grid>
                <Grid item xs={3}>
                    <StyledTextField
                        label="Rate"
                        name="hourlyRate"
                        value={ot.hourlyRate > 0 ? ot.hourlyRate : null}
                        defaultValue={0}
                        variant="filled"
                        type="text"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            inputMode: 'decimal',
                            inputComponent: PriceFormat,
                            inputProps: {
                                inputMode: 'decimal',
                            }
                        }}
                        onChange={event => handleChangeOvertime(event, index)}
                    />
                </Grid>
                <Grid item xs={5}>
                    <StyledFormControl variant="filled" fullWidth >
                        <InputLabel htmlFor="frequency">each</InputLabel>
                        <Select
                            native
                            variant="filled"
                            name="frequency"
                            value={ot.frequency}
                            onChange={event => handleChangeOvertime(event, index)}
                        >
                            {FREQUENCY.map((option, index) => (
                                <option key={"option" + index}>
                                    {option}
                                </option>
                            ))}
                        </Select>
                    </StyledFormControl>
                </Grid>

                <Grid item xs={1} >
                    <Tooltip title={`Delete overtime`} placement="top">
                        <IconButton tabIndex="-1" aria-label="delete" className={classes.deleteButton} size="small" onClick={() => deleteOvertime(index)}>
                            <DeleteIcon fontSize="inherit" />
                        </IconButton>
                    </Tooltip>

                </Grid>



                {ot.frequency !== "Year" && (
                    // WEEK
                    <>
                        <Grid item xs={6} >
                            <StyledTextField
                                fullWidth
                                label={`${ot.frequency}s`}
                                value={ot.annualFrequency > 0 ? ot.annualFrequency : null}
                                defaultValue={0}
                                variant="filled"
                                name="annualFrequency"
                                type="text"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputMode: 'decimal',
                                    inputComponent: FloatFormat,
                                    inputProps: {
                                        inputMode: 'decimal',
                                    }
                                }}
                                onChange={event => handleChangeOvertime(event, index)}
                            />
                        </Grid>

                        <Grid item xs={5}>
                            <StyledTextField
                                fullWidth
                                label={`each`}
                                value={`Year`}
                                variant="filled"
                                disabled
                            />
                        </Grid>
                        <Grid item xs={1}></Grid>
                    </>
                )}

            </Grid>

        </React.Fragment>
    )
}



const checkLimit = (frequency, value, range) => {
    let error = false;
    let index = getIndex(frequency, FREQUENCY);

    if (range === "hoursPerDay") {
        return value > 24;
    }

    switch (range) {
        case "days":
            error = value > DAY_LIMITS[index];
            break;
        case "hours":
            error = value > HOUR_LIMITS[index];
            break;
        case "annual":
            error = value > ANNUAL_LIMITS[index];
            break;
        default:
            break;
    }
    return error;
}

const getIndex = (key, arr) => {
    let match = 0;
    if (isUndefined(arr)) return match
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] === key) match = i;

    }
    return match;
}